import { IMAGES } from "../../../assets/images";

const CustomButton = ({
    buttonStyle = ``,
    textStyle = ``,
    onClick,
    disabled = false,
    loader = false,
    title,
    type = 'button'
}) => {
    const buttonClicked = () => {
        if (disabled) return;
        if (type == 'button') onClick();
    };

    return (
        <button
            type={type} // Prevents accidental form submission if used inside a form
            className={`bg-blue-600 h-[45px] relative flex items-center justify-between w-full rounded-md cursor-pointer transition-opacity duration-500 ease-in-out ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${buttonStyle}`}
            onClick={buttonClicked}
            disabled={disabled || loader} // Automatically disables the button
        >
            <p className={`text-white text-center mb-0 w-full ${textStyle}`}>{title}</p>
            {loader && (
                <img
                    src={IMAGES.Loader}
                    alt="Loader"
                    height={30}
                    width={30}
                    className="absolute right-4"
                />
            )}
        </button>
    );
};

export default CustomButton;
